/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventResponse } from './eventResponse';


export interface RequestAccessResponse { 
    event?: EventResponse;
    /**
     * The access request ID
     */
    request_id?: string;
    /**
     * Access request was successful
     */
    request_successful?: boolean;
}

